'use client';

import { useState } from 'react';
import { AppDownloadModal } from '../../../../components/AppDownloadModal/AppDownloadModal';
import { FAQ } from '../../../../components/FAQ/FAQ';
import { FishingReport } from '../../../../components/FishingReportsGrid/components/FishingReportCard';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import {
  FishingWaterCountryFields,
  FishingWaterRegionFields,
  PlaceTopSpeciesConnectionFields,
  PlaceTopWaterNodeFields,
} from '../../../../generated/graphql';
import { getFAQData } from './helpers/getFAQData';

interface IProps {
  country: FishingWaterCountryFields | null;
  id?: string;
  region: FishingWaterRegionFields | null;
  recentCatchPostList: FishingReport[];
  placeId: string;
  placeName: string;
  placeSlug: string;
  topWaters: PlaceTopWaterNodeFields[];
  topSpeciesSummary?: PlaceTopSpeciesConnectionFields;
}

export const FAQSection = ({
  country,
  id = 'FAQSection',
  region,
  recentCatchPostList,
  placeName,
  placeId,
  placeSlug,
  topWaters,
  topSpeciesSummary,
}: IProps) => {
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  const { currentPage } = useAnalytics();

  const handleCTAClick = (): void => {
    trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'FAQSection',
        source_id: placeId,
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  const faqData = getFAQData({
    country,
    placeName,
    placeSlug,
    handleCTAClick,
    region,
    recentCatchPostList,
    topWaters,
    topSpeciesSummary,
  });

  return (
    <FAQ
      className="mb-md scroll-mt-(--navigation-scrolltop-offset-mobile) sm:scroll-mt-(--navigation-scrolltop-offset)"
      faqData={faqData}
      headingVariant="sm"
      id={id}
      showFAQMetaData
      title={`FAQ about ${placeName} fishing`}
    >
      <AppDownloadModal
        appDownloadSource="FAQSection"
        appDownloadSourceId={placeId}
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </FAQ>
  );
};
